import { headerSearchBarFix, updateContentMargin, modifyFeatureLineup } from './utils/helpers';
import { setNavItemAttributes, updateMenuButton } from './utils/handleNavigation';

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  headerSearchBarFix('Search website');
  updateMenuButton();
  modifyFeatureLineup();
  triggerNewsletter();
  updateContentMargin();

  $(globalThis).on('load', function () {
    setNavItemAttributes();
  });
});

function triggerNewsletter() {
  const $submitBtn = $('.header .emailSubmitButton');
  const $signupBtn = $('.email-signup-content .button');

  $signupBtn.on('click keydown', function (e) {
    e.preventDefault();
    $submitBtn.trigger('click');
  });
}
